import React from 'react'
import { UserAccess } from 'index'

type Props = {
  user: typeof UserAccess
  currentUserId: number
}
export function UserCheckboxItem({ user, currentUserId }: Props) {
  if (currentUserId === user.user_id) {
    return <div>{user.name} (you)</div>
  }

  return <div>{user.name} </div>
}



// WEBPACK FOOTER //
// ./src/components/SurveyAccessFormModal/UserCheckboxItem.tsx